<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <nav>
    <NewsItem class="main news" :selected="selected === 'News'" />
    <PrimaryItem
      v-for="view in views"
      :key="view"
      class="main"
      :to="getViewPath(view)"
      :selected="view === selected">
      {{ view }}
    </PrimaryItem>
    <Archive />
  </nav>
</template>

<script setup>
import PrimaryItem from "@/components/Navigation/Primary/Item.vue";
import NewsItem from "@/components/Navigation/Primary/NewsItem.vue";
import Archive from "@/components/Navigation/Archive.vue";
import {getViewPath} from "@/components/Navigation/Primary/viewPaths";
const props = defineProps(["views", "selected"]); // eslint-disable-line
</script>

<style scoped>
nav {
  flex-grow: 1; /* Fill remaining vertical space */
  /* height: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: -0.4rem 0 0 0; /* compensates for 0.25rem padding on PrimaryItem */
  padding: 0 0 0 0;
  font-size: 1.1rem;
}
.wide nav {
  font-size: 1rem;
}
.medium nav {
  font-size: 0.9rem;
}
/* no primary menu on narrow screens */
.main {
  font-weight: 700;
  /* margin-bottom: 1rem; */
}
/* centered on the header (nearest positioned ancestor), level with the first item */
.news {
  font-size: 1.5em; /* ▶ EDIT HERE: 1.5 × the other header links (was 2.5 ×) */
  position: absolute;
  top: -0.4rem;
  left: 50%;
  transform: translateX(-50%);
}
:deep(a) {
  display: block; /* expand to fill horizontal space of parent <li> */
  color: var(--primary-navigation-color); /* override default link color */
  text-shadow: rgb(0, 0, 0) 0px 0px 6px;
  padding: 0.22rem; /* needed with text-shadow */
  transition: opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
:deep(a:hover) {
  color: var(--primary-navigation-color);
  text-decoration: none;
  opacity: 0.65;
}
</style>
